// Task labels for filtering BTR vs ITR in the unified queue
export const TAX_RETURN_LABEL = {
    BUSINESS: 'business_tax_return',
    INDIVIDUAL: 'individual_tax_return',
} as const;

// On a Preparation or Review task, this return is worked through the Tax Automation surface
export const AUTOMATION_LABEL = 'automation';

// Shared task template names used by both BTR and ITR — derived from the database
export enum TaxTaskTemplateName {
    E_FILE_EXTENSION = 'e_file_extension',
    AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_EXTENSION = 'awaiting_government_acknowledgement_of_extension',
    E_FILE_REJECTION_OF_EXTENSION = 'e_file_rejection_of_extension',
    PAPER_FILE_OF_EXTENSION = 'paper_file_of_extension',
    RECEIPT_OF_BUSINESS_TAX_ORGANIZER = 'receipt_of_business_tax_organizer',
    PREPARATION_OF_TAX_RETURN = 'preparation_of_tax_return',
    REVIEW_OF_TAX_RETURN = 'review_of_tax_return',
    MEMBER_APPROVAL_OF_TAX_RETURN = 'member_approval_of_tax_return',
    E_FILE_OF_TAX_RETURN = 'e_file_of_tax_return',
    AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_TAX_RETURN = 'awaiting_government_acknowledgement_of_tax_return',
    E_FILE_REJECTION_OF_TAX_RETURN = 'e_file_rejection_of_tax_return',
    PAPER_FILE_OF_TAX_RETURN = 'paper_file_of_tax_return',
}

export const BTR_TAX_TASK_TEMPLATE_NAMES = [
    TaxTaskTemplateName.E_FILE_EXTENSION,
    TaxTaskTemplateName.AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_EXTENSION,
    TaxTaskTemplateName.E_FILE_REJECTION_OF_EXTENSION,
    TaxTaskTemplateName.PAPER_FILE_OF_EXTENSION,
    TaxTaskTemplateName.RECEIPT_OF_BUSINESS_TAX_ORGANIZER,
    TaxTaskTemplateName.PREPARATION_OF_TAX_RETURN,
    TaxTaskTemplateName.REVIEW_OF_TAX_RETURN,
    TaxTaskTemplateName.MEMBER_APPROVAL_OF_TAX_RETURN,
    TaxTaskTemplateName.E_FILE_OF_TAX_RETURN,
    TaxTaskTemplateName.AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_TAX_RETURN,
    TaxTaskTemplateName.E_FILE_REJECTION_OF_TAX_RETURN,
    TaxTaskTemplateName.PAPER_FILE_OF_TAX_RETURN,
];

// ITR tasks — same shared templates minus extension tasks
export const ITR_TAX_TASK_TEMPLATE_NAMES = [
    TaxTaskTemplateName.RECEIPT_OF_BUSINESS_TAX_ORGANIZER,
    TaxTaskTemplateName.PREPARATION_OF_TAX_RETURN,
    TaxTaskTemplateName.REVIEW_OF_TAX_RETURN,
    TaxTaskTemplateName.MEMBER_APPROVAL_OF_TAX_RETURN,
    TaxTaskTemplateName.E_FILE_OF_TAX_RETURN,
    TaxTaskTemplateName.AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_TAX_RETURN,
    TaxTaskTemplateName.E_FILE_REJECTION_OF_TAX_RETURN,
    TaxTaskTemplateName.PAPER_FILE_OF_TAX_RETURN,
];

export const TAX_TASK_DISPLAY_NAMES: Record<TaxTaskTemplateName, string> = {
    [TaxTaskTemplateName.E_FILE_EXTENSION]: 'E-File Extension',
    [TaxTaskTemplateName.AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_EXTENSION]:
        'Awaiting Government Acknowledgement of Extension',
    [TaxTaskTemplateName.E_FILE_REJECTION_OF_EXTENSION]: 'E-File Rejection of Extension',
    [TaxTaskTemplateName.PAPER_FILE_OF_EXTENSION]: 'Paper File of Extension',
    [TaxTaskTemplateName.RECEIPT_OF_BUSINESS_TAX_ORGANIZER]: 'Receipt of Business Tax Organizer',
    [TaxTaskTemplateName.PREPARATION_OF_TAX_RETURN]: 'Preparation of Tax Return',
    [TaxTaskTemplateName.REVIEW_OF_TAX_RETURN]: 'Review of Tax Return',
    [TaxTaskTemplateName.MEMBER_APPROVAL_OF_TAX_RETURN]: 'Member Approval of Tax Return',
    [TaxTaskTemplateName.E_FILE_OF_TAX_RETURN]: 'E-File of Tax Return',
    [TaxTaskTemplateName.AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_TAX_RETURN]:
        'Awaiting Government Acknowledgement of Tax Return',
    [TaxTaskTemplateName.E_FILE_REJECTION_OF_TAX_RETURN]: 'E-File Rejection of Tax Return',
    [TaxTaskTemplateName.PAPER_FILE_OF_TAX_RETURN]: 'Paper File of Tax Return',
};

// ITR-specific display names — replaces "Business" with "Individual" where relevant
export const ITR_TASK_DISPLAY_NAMES: Partial<Record<TaxTaskTemplateName, string>> = {
    [TaxTaskTemplateName.RECEIPT_OF_BUSINESS_TAX_ORGANIZER]: 'Receipt of Individual Tax Organizer',
    [TaxTaskTemplateName.PREPARATION_OF_TAX_RETURN]: 'Preparation of Tax Return',
    [TaxTaskTemplateName.REVIEW_OF_TAX_RETURN]: 'Review of Tax Return',
    [TaxTaskTemplateName.MEMBER_APPROVAL_OF_TAX_RETURN]: 'Member Approval of Tax Return',
    [TaxTaskTemplateName.E_FILE_OF_TAX_RETURN]: 'E-File of Tax Return',
    [TaxTaskTemplateName.AWAITING_GOVERNMENT_ACKNOWLEDGEMENT_OF_TAX_RETURN]:
        'Awaiting Government Acknowledgement of Tax Return',
    [TaxTaskTemplateName.E_FILE_REJECTION_OF_TAX_RETURN]: 'E-File Rejection of Tax Return',
    [TaxTaskTemplateName.PAPER_FILE_OF_TAX_RETURN]: 'Paper File of Tax Return',
};
